import React from 'react';
import { Box, Typography, Divider, List, ListItem, ListItemText } from '@mui/material';

export default function About() {
  return (
    <Box sx={{ p: { xs: 1, sm: 2 }, maxWidth: { xs: '100%', sm: 900 }, mx: 'auto' }}>
      <Typography variant="h3" gutterBottom sx={{ fontSize: { xs: '2rem', sm: '2.5rem' } }}>About Us</Typography>
      <Divider sx={{ mb: 3 }} />
      <Typography variant="h5" gutterBottom sx={{ fontSize: { xs: '1.2rem', sm: '1.5rem' } }}>Company Overview</Typography>
      <Typography variant="body1" paragraph>
        Aqeus Healthcare is a diverse combination of resources, skills, and capabilities that provides a platform to excel effectively in today's changing healthcare scenario. We are recognized as a premier pharmaceutical entrepreneur, dedicated to fostering healthier lives through the production of high-quality medicine using the most advanced technology.
      </Typography>
      <Typography variant="body1" paragraph>
        Our company stands out as a provider of a wide range of pharmaceutical formulations, including Ortho, Anti-Analgesic/Spasmodic, Derma, Lotions & Powder, Gynec Range, and many more. We take pride in our cutting-edge manufacturing facilities and adhere to a strict set of standards.
      </Typography>
      <Divider sx={{ my: 3 }} />
      <Typography variant="h5" gutterBottom sx={{ fontSize: { xs: '1.2rem', sm: '1.5rem' } }}>Our Mission</Typography>
      <List>
        <ListItem><ListItemText primary="Adherence to our ethics, customers, employees, and society." /></ListItem>
        <ListItem><ListItemText primary="Consistently set ourselves standards and benchmarks." /></ListItem>
        <ListItem><ListItemText primary="Encouraging innovation & nurturing intellectual growth." /></ListItem>
        <ListItem><ListItemText primary="Persistently improving the quality of our services." /></ListItem>
        <ListItem><ListItemText primary="Our commitment to longer, healthier, and happier lives." /></ListItem>
      </List>
      <Divider sx={{ my: 3 }} />
      <Typography variant="h5" gutterBottom sx={{ fontSize: { xs: '1.2rem', sm: '1.5rem' } }}>Our Vision</Typography>
      <List>
        <ListItem><ListItemText primary="Drive global health through innovative solutions." /></ListItem>
        <ListItem><ListItemText primary="Lead research for impactful medical advancements worldwide." /></ListItem>
        <ListItem><ListItemText primary="Prioritize patient welfare with accessible, quality medications." /></ListItem>
        <ListItem><ListItemText primary="Excel in ethics, building trust through transparency." /></ListItem>
        <ListItem><ListItemText primary="Empower communities with health education and prevention." /></ListItem>
      </List>
      <Divider sx={{ my: 3 }} />
      <Typography variant="h5" gutterBottom sx={{ fontSize: { xs: '1.2rem', sm: '1.5rem' } }}>Our Core Values</Typography>
      <List>
        <ListItem><ListItemText primary="Trust, value, and integrity in all our actions." /></ListItem>
        <ListItem><ListItemText primary="Foster a culture embracing change and new ideas." /></ListItem>
        <ListItem><ListItemText primary="Continuous improvement, creativity, and adaptability." /></ListItem>
        <ListItem><ListItemText primary="Actively contribute to the well-being of communities." /></ListItem>
      </List>
    </Box>
  );
}